import React from 'react';
import { ProfileWithUser } from '../types';
import './ProfileCard.css';

interface ProfileCardProps {
  profile: ProfileWithUser;
  onClick?: () => void;
}

export const ProfileCard: React.FC<ProfileCardProps> = ({ profile, onClick }) => {
  const mainPhoto = profile.photos.sort((a, b) => a.order - b.order)[0];

  return (
    <div className="profile-card" onClick={onClick}>
      <div 
        className="profile-card-image"
        style={{
          backgroundImage: mainPhoto ? `url(${mainPhoto.url})` : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        }}
      >
        {!mainPhoto && (
          <div className="profile-card-no-photo">
            <span>{profile.firstName[0]}</span>
          </div>
        )}
      </div>
      
      <div className="profile-card-content">
        <h2 className="profile-card-name">
          {profile.firstName}, {new Date().getFullYear() - profile.year + 18}
        </h2>
        
        <div className="profile-card-info">
          <p className="profile-card-department">
            📚 {profile.department}
          </p>
          <p className="profile-card-year">
            🎓 Year {profile.year}
          </p>
        </div>

        {profile.bio && (
          <p className="profile-card-bio">{profile.bio}</p>
        )}

        {profile.interests.length > 0 && (
          <div className="profile-card-interests">
            {profile.interests.slice(0, 3).map((interest, index) => (
              <span key={index} className="interest-tag">
                {interest}
              </span>
            ))}
            {profile.interests.length > 3 && (
              <span className="interest-tag">+{profile.interests.length - 3}</span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
